"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = function _default(type) {
  return type === "amp4email" ? "AMP4EMAIL" : type === "amp4ads" ? "AMP4ADS" : null;
};
exports["default"] = _default;